import { useTranslation } from 'react-i18next';
import logo from '@/assets/svg/logo_new.svg';
import classNames from '@/components/LoginViewContent/LoginViewContent.module.scss';

export type RegistrationFormProps = {
  loading?: boolean;
  classCodeErrorObject?: any;
};

const ClassCodeError = ({ classCodeErrorObject }: RegistrationFormProps) => {
  console.log('classCodeErrorObject', classCodeErrorObject);
  const { t } = useTranslation();

  return (
    <div className={classNames.classCodeErrorContainer}>
      <img src={logo} alt={'logo'} />
      <h1>{t(classCodeErrorObject?.title)} 😕</h1>
      <p>{t(classCodeErrorObject?.message)}</p>
      <p>{t(classCodeErrorObject?.code)}</p>
    </div>
  );
};

export default ClassCodeError;
